
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "691dec14-34cb-4eaf-86f3-848091e19b37"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/runner/work/medicalclip-frontend/medicalclip-frontend/medicalclip-frontend/src/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
